import * as http from '../utils/http';



export default function report(query) {
  let url = '/m/v2/?m=api/report/event/click';
  return http.get(url, {
    data: {...query}
  }).then(function (data) {
    return data;
  });
}




// WEBPACK FOOTER //
// ./src/services/report.js